import {
  createLocalizationKey,
  IModal,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  MenuCategories,
  MenuSubcategories,
  StepperCompletionMessageModal,
  ZendraLocalizationServices,
} from '@zendra/shared';

export const COMPLETE_STEPPER_MESSAGE: IModal = {
  asideConfig: { show: false },
  confirmLabel: createLocalizationKey('Confirm', ZendraLocalizationServices.LanguageService),
  dismissLabel: createLocalizationKey('Close', ZendraLocalizationServices.LanguageService),
  backdrop: 'static',
  size: 'md',
  title: createLocalizationKey(
    'StandDivisionAndFusion.CompletedConfirmationMessage',
    ZendraLocalizationServices.Geographic,
  ),
  component: StepperCompletionMessageModal,
  inputs: {
    message: createLocalizationKey(
      'StandDivisionAndFusion.CompletedMessage',
      ZendraLocalizationServices.Geographic,
    ),
  },
};

export const EMPTY_VALUE = '-----';

export const IGNORED_BACKEND_ERROR_CODES = new Set([
  'App:StandFusionStandConsistencyMismatch',
]);

export const VALIDATION_ERROR_KEYS = new Set([
  'HarvestOrderActive',
  'InvalidStand',
  'MinimumSelectionRequired',
  'NewAreaMustBeLowerThanCurrentArea',
  'SelectionRequired',
  'StandAlreadySelected',
]);

export const STANDDIVISIONANDFUSION_CONFIG = {
  entityName: 'StandDivisionAndFusion',
  localizationKey: 'Geographic::StandDivisionAndFusion',
  permission: 'PlanningGeography.StandCycleRotations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory:
    MENU_SUBCATEGORY_KEY + MenuSubcategories.TransactionsPlanning + MENU_NAME_SUFFIX,
};

